const AwarenessManager = () => {

    return (
        <div>This is awareness manager page</div>
    );
}

export default AwarenessManager;